import { render, staticRenderFns } from "./VehicleDatatable.vue?vue&type=template&id=41d51734&"
import script from "./VehicleDatatable.vue?vue&type=script&lang=js&"
export * from "./VehicleDatatable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDatatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
